import { appSettings } from '../../appConfig/appsettings'

/**
 * Returns all data atttributes from root element
 */
let dataAttributes = {}
const useDataAttributes = <Attributes,>(): Attributes => {
    if (Object.keys(dataAttributes).length) return dataAttributes as Attributes

    const ROOT_ELEMENT = document.getElementById(appSettings.rootId)
    const attributes = ROOT_ELEMENT?.attributes
    const numberOfAttributes = attributes?.length || 0
    for (let index = 0; index < numberOfAttributes; index++) {
        const { name, value } = attributes?.item(index) || {}
        if (name?.includes('data-')) {
            const [,key] = name.split('data-')
            dataAttributes = {
                ...dataAttributes,
                [key]: value
            }
        }
        
    }

    return dataAttributes as Attributes
}

export { useDataAttributes }
